import * as React from 'react';

export const ReviewsDividerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6">
  <circle cx="140" cy="100" r="3" fill="#7A7A7A" fillRule="evenodd" transform="translate(-137 -97)"/>
</svg>
);
